// Логика кликов по графику конструктора → пины значений осей (sidebar).
// Чистые функции без Vue — тестируются node --test напрямую.

export const OTHERS_LABEL = 'Прочие';

const isAdditive = (event) => Boolean(
  event && (event.ctrlKey || event.metaKey)
);

// Клик по серии (бар/линия/ячейка) → пин строки оси Y.
// rowBySeriesName: имя серии → метка строки (для комбо-серий «Y · метрика»
// указывает на строку Y); без оси Y карты нет → null.
// ВАЖНО: params.name — категория оси X (дата/значение), имя серии —
// params.seriesName.
export function seriesClickAction(params, rowBySeriesName, event) {
  if (!params || params.componentType !== 'series') return null;
  let value = null;
  if (params.seriesType === 'heatmap') {
    // value: [colIdx, rowIdx, v] — индексы уже с учётом фильтров вкладки
    const raw = Array.isArray(params.value) ? params.value : [];
    const rows = rowBySeriesName.__rows;
    if (Array.isArray(rows)) value = rows[raw[1]] ?? null;
    if (value == null) value = rowBySeriesName[params.seriesName] ?? null;
  } else {
    value = rowBySeriesName[params.seriesName] ?? null;
  }
  if (value == null || value === OTHERS_LABEL) return null;
  return { axis: 'y', value, additive: isAdditive(event) };
}

// Клик по подписи оси (axisLabel) → пин значения этой оси.
// axis: 'x' | 'y' — какая ось кликнута; для времени/«Прочие» — null.
export function axisClickAction(params, axis, event) {
  if (
    !params ||
    params.componentType !== `${axis}Axis` ||
    params.targetType !== 'axisLabel'
  ) {
    return null;
  }
  const value = params.value;
  if (value == null || value === OTHERS_LABEL) return null;
  return { axis, value: String(value), additive: isAdditive(event) };
}

// Новое значение пина оси: одиночный клик — «только это» (повторный клик по
// единственному запиненному значению снимает пин), Ctrl/Cmd — переключение
// в мультивыборе с учётом кэпа.
export function pinValue(current, value, { additive, cap = Infinity }) {
  const list = Array.isArray(current) ? current : [];
  if (additive) {
    if (list.includes(value)) return list.filter((v) => v !== value);
    if (list.length >= cap) return list;
    return [...list, value];
  }
  if (list.length === 1 && list[0] === value) return [];
  return [value];
}
